/* Hook encargado de crear o modificar  la reserva

Autor: Benjamín León
Fecha: 2024-10-01
*/
import { useState } from 'react'

import Reservation from '../interfaces/Reservation.ts'
import { normalizeDate } from '../utils/utils.ts'
import { customPost } from '../utils/customFetch.ts'

import { useAuth } from './useAuth.tsx'
import { makeUrlReservationCrea, makeUrlReservationEdit } from './connectionData.tsx'

const useReservationCrea = () => {
  const [errorReservationCrea, setErrorReservationCrea] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const { userData } = useAuth()

  const reservationCrea = async (reservation: Reservation, accion: number) => {
    setLoading(true)

    try {
      const apiUrl = accion === 0 ? makeUrlReservationCrea() : makeUrlReservationEdit()
      // Tenemos que cambiarle las fechas a
      // los pagos, costos

      ;(reservation.additionals ?? []).forEach((element) => {
        element.date = normalizeDate(element.date)
      })
      ;(reservation.payments ?? []).forEach((element) => {
        element.date = normalizeDate(element.date)
      })
      // Y le quitamos datos extras
      delete reservation.footer
      const res = await customPost<{ _id: string }>(apiUrl, {
        ...reservation,
        user_id: userData?.user?._id,
        date: normalizeDate(reservation.date),
      })

      setErrorReservationCrea(null)

      return res._id
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorReservationCrea(err)
      } else {
        setErrorReservationCrea(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorReservationCrea, loading, reservationCrea }
}
export default useReservationCrea
